<template>
  <div class="flex items-center justify-center h-screen bg-gray-100">
    <div class="relative">
      <div
        class="w-16 h-16 rounded-full border-4 border-t-accent-500 border-r-accent-500 border-b-brand-600 border-l-gray-200 animate-spin"
      />
      <div
        class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-4 h-4 rounded-full bg-accent-500 animate-pulse"
      />
      <div
        class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2 h-2 rounded-full bg-white"
      />
    </div>
  </div>
</template>

<script setup>
</script>